import UAEIcon from "../Assets/dungeon.png";
import Dubai from "../Assets/Vector-2.png";
import Offshore from "../Assets/Vector-1.png";
import Advice from "../Assets/Group.png";
import Bank from "../Assets/ILLUSTRATION 03  1.png";
import Registration from "../Assets/Group-1.png";
import Visas from "../Assets/Group-2.png";
import FaceBook from "../Assets/Vector-5.png";
import Instagram from "../Assets/Vector-6.png";
import Youtube from "../Assets/Vector-7.png";
import LinkdIn from "../Assets/Vector-8.png";

export const HeroData = {
  title: "Get started on fulfilling your Dubai or UAE dream.",
  desc: "We provide you with information about UAE or Offshore Company Registration & help you setup your company with a bank account and visas.",
  subtitle1: "Claim a Free Quote",
  subtitle2: "UAE & Offshore Company",
  btn1: "Start a Company",
  btn2: "Renew a Company",
  ads: "Watch the video about UAE or Offshore Company Registration",
};

export const ServiceSection = {
  title: "Dedicated to our mission we are",
  desc: `Our services include Company Formation & Renewals,
    Trust & Fiduciary, Tax Residency Setup With Family, Bank
    Accounts, Remote Management, Stock Trading
    Platforms, Ownership Solutions.`,
  companylist: [
    {
      icon: `${UAEIcon}`,
      title: `UAE Free Zone Company`,
      desc: `Your registration agent, will answer all
            of your questions and help you to reach
            a conclusion that meets your objectives
            of investing in the UAE.`,
    },
    {
      icon: `${Dubai}`,
      title: `Dubai Local Companies`,
      desc: `The Dubai LLC formation documents
            are actually articles of organization or a
            certificate of organization. You can get
            yours today.`,
    },
    {
      icon: `${Offshore}`,
      title: `Offshore Compamies`,
      desc: `You can register an offshore company
            and open its bank account in Dubai.
            Your agent will help you along all the
            process`,
    },
  ],
};

export const ServiceCardDetails = {
  title1: `Learn the ways in which you can benefit
    from a UAE/Offshore Company. Then get
    started on fulfilling your UAE dream.`,
  subtitle1: `Claim a Free Quote`,
  title2: `We have gathered a team of
    professionals to craft adequate
    services you can rely on for a friction
    free setup in UAE.`,
  subtitle2: `More about our services`,
  cardslistleft: [
    {
      isTitle: false,
      icon: `${Bank}`,
      title: `Bank Account Setup`,
      desc: `There are many banks in the United
      Arab Emirates [UAE]. Both locally
      owned and branches of
      multinational ones. Foreign banks
      adjust according to their parent s
      strategies and have changed local
      requirements overnight in the past.
      But we are here to help you.`,
      link: "",
    },
    {
      isTitle: false,
      icon: `${Visas}`,
      title: `UAE Company Visas`,
      desc: `Your application for visas is critical
      especially if you intend to move to
      Dubai. This becomes even more
      urgent if your family will also move
      with you. All the paperwork is done
      on your behalf smoothly so that you
      may only focus on doing what
      matters most to you.`,
      link: "",
    },
  ],
  cardlistright: [
    {
      isTitle: false,
      icon: `${Advice}`,
      title: `Advice & Guidance`,
      desc: `All activities in the UAE are licensed.
        Whether manufacturing, finance,
        trading, marketing, consultancy or
        restaurants. In some countries only
        manufacturing is licensed. In others
        there is a threshold below which
        business are encouraged. Get our
        insightfull guidance today.`,
      link: "",
    },
    {
      isTitle: false,
      icon: `${Registration}`,
      title: `Registration Document
          Perparation`,
      desc: `Several documents must be
          prepared to start the process of
          registering a new company in the
          United Arab Emirates. Be it a Dubai
          local company, a free zone one or an
          offshore entity. Your registered
          agent is dedicated to get this done
          for you for a seamless process.`,
      link: "",
    },
  ],
};

export const PriceCard = {
  title: `Most popular affordable pricing per
    jurisdictions are brought to you to
    kick off your adventure.`,
  cardlist: [
    {
      cardtitle: `AJMAN OFFSHORE`,
      cardprice: `$2,997`,
      cardsubtitle: `Ajman Offshore New Company
      formation includes`,
    },
    {
      cardtitle: `RAK ICC`,
      cardprice: `$2,997`,
      cardsubtitle: `Rak Icc New Company formation
      includes`,
    },
    {
      cardtitle: `SHARJAH MEDIA CITY`,
      cardprice: `$4,124`,
      cardsubtitle: `Sharjah Media City New
      Company formation include`,
    },
  ],
  features: [
    "Attestation Charges",
    "Registered Agent",
    "Registered Office",
    "Varal Administrative",
    "Preparing Statutory File",
    "Liasing with Registration Authorities",
    "Due Diligence Appraisal",
    "Keeping The Register",
    "Seal Charges",
    "Certificate of Good Standing",
  ],
};

export const blogsData = {
  title: `Read about our blogs for more 
    information on our processes `,
  blogList: [
    {
      title: `How to start a company
            formation in Dubai`,
      time: `5 Minutes`,
    },
    {
      title: `How to start an Offshore 
        company formation in Dubai`,
      time: `5 Minutes`,
    },
    {
      title: `SEO Dubai: Who benefits 
        the most?`,
      time: `5 Minutes`,
    },
  ],
};

export const CustomerFeedback = {
  title: `Satidfied We are When Our 
  Customers Are Happy `,
  comments: [
    {
      icon: "",
      comment: `I am very happy with them. I’ll 
            continue to use their services in 
            future & highly recommend them 
            to anyone`,
      name: `Muhib Abrar`,
    },
    {
      icon: "",
      comment: `Rama has a high level of integrity, 
      intellect, knowledge of his 
      business, resourcefulness and 
      humanity,`,
      name: `Colin Saldahna`,
    },
    {
      icon: "",
      comment: `Your advise was so complete that I 
      actually realized how beneficial 
      this would be to my clients and my 
      business.`,
      name: `Mark Swann`,
    },
  ],
};

export const aboutUsData = {
  title: `Get to know the whole us and 
  more of our services`,
  dataList: [
    {
      title: `Service`,
      itemList: [
        { item: `Products`, link: `` },
        { item: `Solutions`, link: `` },
        { item: `Assurance`, link: `` },
        { item: `FAQ`, link: `` },
        { item: `Working at Varal-Singhania`, link: `` },
      ],
    },
    {
      title: `Policies`,
      itemList: [
        { item: `Privacy Policy`, link: `` },
        { item: `Terms & Conditions`, link: `` },
      ],
    },
    {
      title: `About`,
      itemList: [
        { item: `About Us`, link: `` },
        { item: `Contact Us`, link: `` },
      ],
    },
    {
      title: `Address`,
      itemList: [
        {
          item: `608 One Lake Plaza, Cluster T,

            Al Sarayat Street, Jumeirah 
            Lake Towers
            
            Dubai
            
            United Arab Emirates`,
        },
        {
          item: `Office Hours: Sunday to 
               Thursday 8:30 AM to 6:30 PM 
               [GMT+4]
               
               M: +971 55 794 2016
               
               O: +971 4 447 2061`,
        },
      ],
    },
    {
      title: `Subscribe Now`,
      itemList: [
        { item: `Subscribe now to receive our
        Newsletters about amazing
        opportunities in Dubai`, link: `` },
      ],
    },
  ],
  socialMedia: [
    {
      icon: `${FaceBook}`,
      link: ``,
    },
    {
      icon: `${Instagram}`,
      link: ``,
    },
    {
      icon: `${Youtube}`,
      link: ``,
    },
    {
      icon: `${LinkdIn}`,
      link: ``,
    },
  ],
};
